

































































































































import { useSettings } from '@/composable/repositories/useSettings';
import { useToasts } from '@/composable/useToasts';
import { api } from '@/libs/api';
// import { CustomerResponse } from '@futureecom/futureecom-js/dist/services/customer-service';
import CustomerResponse from "@futureecom/futureecom-js/dist/services/customer-service"
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import axios from 'axios'
import { VSelect } from 'vuetify/lib'; // Make sure Vuetify components are imported properly

export default defineComponent({
  name: 'CustomerDocuments',
  components: {
    VSelect,
  },
  props: {
    value: {
      type: Object as () => CustomerResponse,
      required: true,
    },
  },
  setup(props, { emit }) {

    const { getStoreSetting } = useSettings()
    const storeAddress = getStoreSetting('general.contact.address')

    const { addSuccessToast } = useToasts();
    const textid = ref();
    const imageURL = ref();
    const status = ref();
    const TaxExemptionNote = ref();
    const loading = ref(false);
    const loadingData = ref(true);
    const dialog = ref(false); // Dialog for refund form
    const color =  ref('')
    const address = ref('')
    const orderId = ref('#ORDER1234')
    const typeError = ref(false)
    const loadingUpload = ref(false)
    // Refund form data
    const refundFormData = ref({
      name: '',
      email: '',
      refundPrice: 0,
      textArea: ''
    });

    const statusOptions :any = [
      { text: 'Approved', value: 'approved' },
      { text: 'Pending', value: 'pending' },
      { text: 'Not approved', value: 'nonapproved' },
      { text: 'Non Active', value: 'nonactive' },
    ];

    const filteredStatusOptions = computed(() => {
      // Filter out 'Non Active' if textid exists
      return textid.value
        ? statusOptions.filter((option:any) => option.value !== 'nonactive')
        : statusOptions;
    });


    const customer = computed({
      get: () => props.value,
      set: (val) => emit('input', val),
    });


    
    const handleFileUpload = async (event: any) => {
      if(event){
      typeError.value = false
      const allowedExtensions = ['jpg', 'jpeg', 'pdf', 'png'];
      // Extract the file extension
      const fileExtension = event.name.split('.').pop().toLowerCase();
      // Check if the file extension is allowed
      if (!allowedExtensions.includes(fileExtension)) {
        typeError.value = true
        setTimeout(() => {
          typeError.value = false
        }, 2000);
        return; // Stop further execution
      }
      typeError.value = false
      loadingUpload.value = true;
      const formData = new FormData();
      formData.append('file', event);
      formData.append('upload_preset', 'pdf_upload');
      formData.append('cloud_name', 'dgjpcpp4s');

      try {
        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dgjpcpp4s/raw/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        imageURL.value  = response.data.secure_url;
      } catch (error) {
        console.error('Error uploading file:', error);
      } finally {
        loadingUpload.value = false;
      }
      }
    };

    const taxExemptionData = () => {
      api.client
        .get(`epic/tax-exemption?email=${(customer.value as any).email}`)
        .then((response: any) => {
          textid.value = response.data.TaxExemptionID;
          status.value = response.data.TaxExemptionStatus ? response.data.TaxExemptionStatus : 'nonactive' ;
          imageURL.value = response.data.TaxExemptionImageURL;
          TaxExemptionNote.value = response.data.TaxExemptionNote;
        })
        .catch((err: any) => {
          console.log(err);
        })
        .finally(() => {
          loadingData.value = false;
        });
    };

    const updateData = () => {
      loading.value = true;
      const taxExemptionData = {
        email: (customer.value as any).email,
        TaxExemptionID: textid.value,
        TaxExemptionImageURL: imageURL.value,
        TaxExemptionStatus: status.value,
        TaxExemptionNote: TaxExemptionNote.value,
      };

      if (status.value !== 'nonapproved') {
        taxExemptionData.TaxExemptionNote = '';
      }

      api.client
        .post('epic/tax-exemption', taxExemptionData)
        .then((response: any) => {
          addSuccessToast('Updated Exemption successfully');
        })
        .catch((err: any) => {
          console.log(err);
        })
        .finally(() => (loading.value = false));
    };


    const getStore = async () => {
      try {
        const response = await api.client.get('epic/get_store_data')
        const qhcolor = Object.values(response.data.data)
          .flatMap((item: any) => item.stores)
          .find(store => store.code === 'qualifiedh')?.color;
        color.value = qhcolor
      } catch (error) {
        console.error("Error fetching store data:", error)
      }
    }
    onMounted(() => {
      getStore()
    })

    const handleSubmit = () => {
  try {
    address.value = `<span>@${storeAddress.name} </span><span>${storeAddress.street}, </span><span>${storeAddress.city}, </span><span>${storeAddress.region}, </span><span>${storeAddress.postcode}, </span><span>${storeAddress.country_code} </span>`
    const formData = new FormData();
    formData.append('from', 'epc@qualifiedhardware.com');
    formData.append('to', refundFormData.value.email);
    formData.append('subject', 'Additional Information Required for Refund');

    formData.append(
      'body',
      `
      <table width="100%" cellpadding="0" cellspacing="0" bgcolor="#DCDDE1" border="0" style="background-color: #dcdde1; padding: 20px 10px;">
        <tr>
          <td align="center" style="letter-spacing: 0.3px; width: 88%; text-align: center; padding-left: 15px; padding-right: 15px;">
            <div style="width: 100%; margin: 0 auto; max-width: 640px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; margin: 0 auto;">
                <tbody>
                  <!-- Top bar color -->
                  <tr>
                    <td bgcolor=${color.value} align="center" style=" height: 10px;"></td>
                  </tr>
                  <!-- Logo -->
                  <tr>
                    <td bgcolor="#fff" align="center" style="padding: 10px 0; border-bottom: 1px solid #e1e1e1;">
                      <p style="margin: 0;">
                        <a href="#"><img src="https://res.cloudinary.com/dgjpcpp4s/image/upload/v1723212228/fjzhuhfnigmhti1prgvb.png" alt="qualifiedh" style="max-width: 150px; height: auto;"></a>
                      </p>
                    </td>
                  </tr>
                  <!-- Content -->
                  <tr>
                    <td bgcolor="#ffffff">
                      <table width="100%" cellpadding="0" cellspacing="0" border="0">
                        <tbody>
                          <tr>
                            <td width="100%" align="center" style="padding: 10px 0">
                              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                <tbody>
                                  <!-- Customer Greeting -->
                                 <tr>
                                      <td valign="top" style="font-family: Verdana, sans-serif; color: #74737b; text-align: left; padding-bottom: 10px; padding-left: 15px;"> <!-- Added padding-left here -->
                                        <table cellpadding="0" cellspacing="0" width="100%;">
                                          <tr>
                                            <td style="font-size: 16px; font-family: Verdana, sans-serif;" width="300">
                                              Dear ${refundFormData.value.name},
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                 </tr>
                                  <!-- Refund Details -->
                                  <tr>
                                    <td style="font-family: Verdana, sans-serif; color: #74737b; text-align: left; padding-bottom: 10px; padding-left: 15px; padding-right: 15px;">
                                      <p style="font-size: 14px; color: #383838; font-family: Verdana, sans-serif;">We are currently processing your refund request for order ${orderId.value}, in the amount of $${refundFormData.value.refundPrice}. However, we require some additional information to proceed with the refund to your bank account. Please provide us with the following bank details:</p>
                                      <ul style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">
                                        <li>Bank Name</li>
                                        <li>Account Number</li>
                                        <li>Account Holder's Name</li>
                                        <li>SWIFT/BIC Code (if applicable)</li>
                                      </ul>
                                      <p style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">Once we receive the requested information, we will continue processing your refund. We apologize for any inconvenience this may cause and appreciate your cooperation.</p>
                                      <p style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">Note: ${refundFormData.value.textArea}</p>
                                      <p style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">If you have any questions, please don't hesitate to contact us at epc@qualifiedhardware.com.</p>
                                      <p style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">Best regards,</p>
                                      <p style="font-size: 12px; color: #383838; font-family: Verdana, sans-serif;">Qualified Hardware Team</p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <!-- Footer -->
                  <tr>
                    <td bgcolor="#ffffff" align="center" style=" padding: 10px 0 0; border-top: 1px solid #e1e1e1;">
                      <a href="#"><img src="https://res.cloudinary.com/dgjpcpp4s/image/upload/v1723212229/bam3hja9tgn0ce2f1wzt.png" alt="qualifiedh" style="width: 120px; height: auto;"></a>
                    </td>
                  </tr>
                  <tr> 
                  <td bgcolor="#ffffff" align="center" style=""> 
                  <p style="font-size: 10px; padding-bottom: 15px; color: #808080c7; font-family: Verdana, sans-serif; width: 100%;"> ${address.value} </p> 
                  </td> 
                  </tr> 
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </table>
      `
    );

    api.client
      .post('epic/email-smtp', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response: any) => {
        addSuccessToast('Email sent successfully');
        console.log('Email sent:', response);
      })
      .catch((err: any) => {
        console.error('Error sending email:', err);
      });
  } catch (error) {
    console.error('Error handling email submission:', error);
  }
};



    const submitRefundForm = () => {
      if (refundFormData.value.name && refundFormData.value.email && refundFormData.value.refundPrice > 0) {
        dialog.value = false; // Close the dialog after submission
        handleSubmit()
         // Reset form fields 
        refundFormData.value = {
          name: '',
          email: '',
          refundPrice: 0,
          textArea : ''
        };
      } else {
        console.error('Refund Form is incomplete');
      }
    };

    onMounted(() => {
      taxExemptionData();
    });

    return {
      customer,
      textid,
      imageURL,
      statusOptions,
      status,
      updateData,
      loading,
      loadingData,
      TaxExemptionNote,
      dialog,
      refundFormData,
      submitRefundForm,
      color,
      orderId,
      storeAddress,
      address,
      filteredStatusOptions,
      typeError,
      handleFileUpload,
      loadingUpload
    };
  },
});
